import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Container,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  Modal,
  Button,
} from "react-bootstrap";
import api from "../../services/api";
import { useAuth } from "../../context/auth";
import Template from "../../template";

import ListaAlunos from "../ListaAlunos";
import ListaRedacoes from "../ListaRedacoes";

import * as S from "./styled";

function Classe(props) {
  const { user } = useAuth();
  const date1 = new Date();

  const { id } = props.match.params;

  const [loading, setLoading] = useState(true);

  /* { tipo: "aviso" | "atividade", id, titulo } — null quando o modal está fechado. */
  const [confirmacao, setConfirmacao] = useState(null);
  const [excluindo, setExcluindo] = useState(false);
  const [classe, setClasse] = useState([]);

  const [lgShow, setLgShow] = useState(false);

  const [apoio, setApoio] = useState("");
  const [arquivo, setArquivo] = useState("");
  const [nomeAtividade, setNomeAtividade] = useState("");

  const [aviso, setAviso] = useState("");
  const [avisos, setAvisos] = useState([]);
  const [showAvisos, setShowAviso] = useState(true);

  const [showRedacoes, setShowRedacoes] = useState(false);

  const [atividades, setAtividades] = useState([]);
  const [showAtividades, setShowAtividades] = useState(false);
  const [disponiveis, setDisponiveis] = useState(true);
  const [tipo, setTipo] = useState("Todos");

  // eslint-disable-next-line no-unused-vars
  const [alunos, setAlunos] = useState([]);
  const [showAlunos, setShowAlunos] = useState(false);

  const [clicado, setClicado] = useState(false);

  const [tipoRedacao, setTipoRedacao] = useState(0);

  /* cadastrar aviso */
  const handleAviso = async () => {
    const data = {
      aviso,
      turma_id: id,
      data: date1,
    };

    try {
      const retorno = await api.post(`/classe/aviso`, data);

      setAvisos([
        {
          id: retorno.data.id,
          aviso,
          turma_id: id,
          data: date1,
        },
        ...avisos,
      ]);

      setAviso("");
      toast.success("Aviso enviado com sucesso!");
    } catch (err) {
      toast.error("Erro ao enviar aviso!");
    }
  };

  /*
    Exclusão de aviso e de atividade passam por confirmação: o botão fica na quina do
    card e apagava na hora, sem volta. Um estado só atende os dois — a diferença é a
    rota e a lista que precisa ser atualizada.
  */
  const executarExclusao = async () => {
    if (!confirmacao) return;

    const { tipo, id } = confirmacao;
    const ehAviso = tipo === "aviso";

    setExcluindo(true);

    try {
      await api.delete(`${ehAviso ? "/deleteAviso" : "/deleteAtividade"}/${id}`);

      if (ehAviso) {
        setAvisos((atuais) => atuais.filter((x) => x.id !== id));
        toast.success("Aviso deletado com sucesso!");
      } else {
        setAtividades((atuais) => atuais.filter((x) => x.id !== id));
        toast.success("Atividade deletada com sucesso!");
      }

      setConfirmacao(null);
    } catch (err) {
      toast.error(ehAviso ? "Erro ao deletar aviso!" : "Erro ao deletar atividade!");
    } finally {
      setExcluindo(false);
    }
  };

  /* configuração para exibição de itens */
  const mostrarItens = (item) => {
    setLoading(true);
    if (item === "avisos") {
      setShowAviso(true);
      setShowAtividades(false);
      setShowAlunos(false);
      setShowRedacoes(false);
      setLoading(false);
    } else if (item === "atividades") {
      getAtividades();
      setShowAviso(false);
      setShowAtividades(true);
      setShowAlunos(false);
      setShowRedacoes(false);
    } else if (item === "alunos") {
      getAlunos();
      setShowAviso(false);
      setShowAtividades(false);
      setShowAlunos(true);
      setShowRedacoes(false);
    } else if (item === "redacoes") {
      setShowAviso(false);
      setShowAtividades(false);
      setShowAlunos(false);
      setShowRedacoes(true);
      setLoading(false);
    }
  };

  /* recuperar termas/atividades da classe */
  const getAtividades = async () => {
    const data = {
      id_classe: id,
    };

    try {
      // Se for uma turma "Somente IA", usar o endpoint específico
      if (classe.type === "Somente IA") {
        try {
          const retorno = await api.post(`/getAtividades/ia`, data);
          
          // Buscar dados completos dos temas para garantir arquivo e descrição
          let temasCompletos = await api.get('/pegarTemasGeral');
          
          // Mapear atividades e adicionar dados completos dos temas
          const atividadesCompletas = retorno.data.map((atividade) => {
            const temaCompleto = temasCompletos.data.find(tc => tc.id === atividade.tema_id || tc.id === atividade.id);
            return {
              ...atividade,
              arquivo: atividade.arquivo || (temaCompleto ? temaCompleto.arquivo : null),
              descricao: atividade.descricao || (temaCompleto ? temaCompleto.descricao : null)
            };
          });
          
          setAtividades(atividadesCompletas);
          setLoading(false);
          return;
        } catch (error) {
          // Se o endpoint de IA falhar, usar o endpoint padrão como fallback
          console.log('Endpoint /getAtividades/ia não disponível, usando fallback');
        }
      }

      // Para turmas normais ou fallback
      const dataDefault = {
        id,
        tipo,
        disponiveis,
        temaId: 0,
      };

      const retorno = await api.post(`/getAtividades/`, dataDefault);
      
      // Buscar dados completos dos temas para garantir arquivo e descrição
      let temasCompletos = await api.get('/pegarTemasGeral');
      
      console.log('=== DADOS DA API CLASSE ===');
      console.log('Atividades retornadas:', retorno.data.atividades);
      console.log('Temas completos:', temasCompletos.data);
      
      // Mapear atividades e adicionar dados completos dos temas
      const atividadesCompletas = retorno.data.atividades.map((atividade) => {
        const temaCompleto = temasCompletos.data.find(tc => tc.id === atividade.tema_id || tc.id === atividade.id);
        const atividadeCompleta = {
          ...atividade,
          arquivo: atividade.arquivo || (temaCompleto ? temaCompleto.arquivo : null),
          descricao: atividade.descricao || (temaCompleto ? temaCompleto.descricao : null)
        };
        console.log('Atividade processada:', atividadeCompleta);
        return atividadeCompleta;
      });
      
      setAtividades(atividadesCompletas);
      setLoading(false);
    } catch (err) {
      toast.error("Erro ao recuperar atividades!");
      setLoading(false);
    }
  };

  /* recuperar alunos e redações da classe */
  const getAlunos = async () => {
    try {
      const retorno = await api.get(`/getAlunos/${id}`);

      setAlunos(retorno.data);
      setLoading(false);
    } catch (err) {
      toast.error("Erro ao recuperar alunos!");
    }
  };

  /* Validar datas se esta ou não expirado */
  const validaDataClasse = (dataTema, horaTema) => {
    let strData = dataTema;
    let srtHora = horaTema;

    var arr = `${strData} ${srtHora}`.split(/[- :]/);
    const validarData = new Date(
      arr[0],
      arr[1] - 1,
      arr[2],
      arr[3],
      arr[4],
      arr[5]
    );

    if (validarData > date1) {
      return false;
    } else {
      return true;
    }
  };

  /* formatar data para o padrão BR */
  const formatarData = (dataTurma) => {
    if (dataTurma) {
      let dataFinal = dataTurma.split("T");

      return dataFinal[0].split("-").reverse().join("/");
    }
  };

  const getTypeClass = async () => {
    
    try {
      const retorno = await api.get(`/getClasse/${id}`);
      console.log(retorno);

      
      return retorno.data[0].type === 'Internet' ? 1 : 0;

    }catch(err){
      toast.error("Erro ao recuperar tipo da classe!");
    }

  };

  /* criar redação/atividade */
  const criarRedacao = async (id, rc_id, turma_id) => {
    console.log('criarRedacao chamada:', { 
      tema_id: id, 
      atividade_id: rc_id, 
      turma_id: turma_id, 
      classeType: classe.type 
    });
    
    // Se for uma turma "Somente IA", redireciona diretamente para a página de upload de IA
    if (classe.type === "Somente IA") {
      const urlRedirecionamento = `/redacao-ia/${turma_id}/${id}`;
      console.log('Construindo URL:', {
        turma_id,
        tema_id: id,
        url_final: urlRedirecionamento
      });
      console.log('Redirecionando para:', urlRedirecionamento);
      props.history.push(urlRedirecionamento);
      setClicado(false);
      return;
    }

    // Se for uma turma UERJ, usa o endpoint específico /escolha
    if (classe.type === "UERJ") {
      const dataUERJ = {
        classe_id: turma_id,
        tema_id: id
      };

      try {
        let response = await api.post("/escolha", dataUERJ);
        
        if (response.status === 201) {
          toast.success("Redação criada com sucesso! Você pode agora enviar sua redação.");
          setShowAviso(false);
          setShowAtividades(false);
          setShowAlunos(false);
          setShowRedacoes(true);
          setClicado(false);
          return;
        }
      } catch (error) {
        if (error.response?.status === 409) {
          toast.error("Já existe uma redação para este tema nesta turma");
        } else if (error.response?.status === 400) {
          toast.error("Dados obrigatórios não fornecidos");
        } else {
          toast.error("Erro interno do servidor");
        }
        setClicado(false);
        return;
      }
    }

    const dataTheme = {
      id,
      rc_id,
      turma_id,
      tipo: tipoRedacao
    };

    let response = await api.post("/redacoes", dataTheme);

    if (
      response.data.message === "Já existe uma redação cadastrada com este tema"
    ) {
      toast.error(
        "Você já tem uma redação com este tema, iremos lhe redirecionar para suas redações"
      );
    } else if (response.status === 200) {
      toast.success(
        "Redação adicionada com sucesso, vamos mover você até sua área de redações"
      );
    }

    setShowAviso(false);
    setShowAtividades(false);
    setShowAlunos(false);
    setShowRedacoes(true);
    setClicado(false);
  };

  useEffect(() => {


    /* pegar a classe que esta ao carregar o componente */
    async function getClasse() {
      try {
        let response = await api.get(`/getClasse/${id}`);
     
        setTipoRedacao(response.data[0].type === 'Internet' ? 1 : 0)
        setClasse(response.data[0]);
      } catch (err) {
      } finally {
        return false;
      }
    }

    /* já recuperamos os avisos que existem para a turma */
    const getAvisos = async () => {
      try {
        let response = await api.get(`/getAvisos/${id}`);

        setAvisos(response.data);
      } catch (err) {
      } finally {
        return false;
      }
    };

    /* confirmar se existe turma */
    if (id) {
      getClasse();
      getAvisos();

      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [id]);

  useEffect(() => {
    setLoading(true);
    try {
      getAtividades();
    } catch (err) {
      toast.error("Erro ao enviar aviso!");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipo, disponiveis]);

  return (
    <Template>
      <S.MainWrapper>
        <Container fluid>
          <Row>
            <Col sm={12} md={8}>
              <S.WrapperTurma>
                <strong>{classe.name}</strong>
                <br />
                {classe && formatarData(classe?.created_at)}
              </S.WrapperTurma>
            </Col>
            <Col sm={12} md={4}>
              <Row>
                <Col sm={12}>
                  <div
                    className="alert alert-info alinhar-icone-texto"
                    role="alert"
                    onClick={() => mostrarItens("avisos")}
                  >
                    <S.NewspaperIcon /> Mostrar Avisos
                  </div>
                </Col>
                <Col sm={12}>
                  <div
                    className="alert alert-info alinhar-icone-texto"
                    role="alert"
                    onClick={() => mostrarItens("redacoes")}
                  >
                    <S.PencilSquareIcon /> Minhas Redações
                  </div>
                </Col>
                {user.nivel === "a" && (
                  <Col sm={12}>
                    <div
                      className="alert alert-info alinhar-icone-texto"
                      role="alert"
                      onClick={() => mostrarItens("alunos")}
                    >
                      <S.SchoolIcon /> Mostrar Alunos
                    </div>
                  </Col>
                )}
                <Col sm={12}>
                  <div
                    className="alert alert-info alinhar-icone-texto"
                    role="alert"
                    onClick={() => mostrarItens("atividades")}
                  >
                    <S.CategoryIcon /> Mostrar Atividades
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          {loading ? (
            <Row>
              <Col className="text-center">
                <div className="shadow p-3 mb-4 bg-white rounded fdark flex-c">
                  <div>
                    <div className="spinner-grow text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-grow text-secondary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-grow text-success" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-grow text-danger" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-grow text-warning" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    <div className="spinner-grow text-info" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                  <div>
                    <strong>CARREGANDO</strong>
                  </div>
                </div>
              </Col>
            </Row>
          ) : (
            <>
              {showAvisos && (
                <>
                  <Row>
                    <Col>
                      <div className="shadow-sm p-3 mb-4 bg-white rounded fdark">
                        <strong>Mural de Avisos</strong>
                      </div>
                    </Col>
                  </Row>
                  {user.nivel === "a" && (
                    <Row>
                      <Col>
                        <S.FormularioAviso>
                          <S.AvisoTipoIcon>
                            <S.PaperPlaneIcon />
                          </S.AvisoTipoIcon>
                          <div className="flex100 flex-c">
                            <textarea
                              className="form-control"
                              onChange={(e) => setAviso(e.target.value)}
                              placeholder="Escreva um aviso para a turma"
                              value={aviso}
                            />
                            <button
                              className="btn btn-info btn-blue btn-xs"
                              onClick={handleAviso}
                            >
                              Enviar
                            </button>
                          </div>
                        </S.FormularioAviso>
                      </Col>
                    </Row>
                  )}

                  <Row>
                    {avisos &&
                      avisos.map((aviso) => (
                        <Col xs={12} key={aviso.id}>
                          <S.AvisoContainer className="shadow p-3 mb-4 bg-white rounded fdark dele">
                            {user.nivel === "a" && (
                              <S.TopButton
                                onClick={() =>
                                  setConfirmacao({
                                    tipo: "aviso",
                                    id: aviso.id,
                                    titulo: aviso.aviso,
                                  })
                                }
                              >
                                <OverlayTrigger
                                  key="top"
                                  placement="top"
                                  overlay={<Tooltip>Deletar</Tooltip>}
                                >
                                  <S.DeletarIcone />
                                </OverlayTrigger>
                              </S.TopButton>
                            )}
                            <div style={{display: 'flex', alignItems: 'flex-start', padding: '15px'}}>
                              <S.AvisoTipoIcon>
                                <S.NewspaperIcon />
                              </S.AvisoTipoIcon>
                              <S.AvisoContent>
                                <strong>{aviso.aviso}</strong>
                                <small>{formatarData(aviso.created_at)}</small>
                              </S.AvisoContent>
                            </div>
                          </S.AvisoContainer>
                        </Col>
                      ))}
                  </Row>
                </>
              )}

              {showAtividades && (
                <>
                  <Row>
                    <Col>
                      <S.CabecalhoAtividades>
                        <strong>Atividades da Classe</strong>
                        {user.nivel === "a" && (
                          <Link to={`/atividades/${id}`} style={{textDecoration: 'none'}}>
                            <S.BotaoNovaAtividade>
                              <S.CreateIcon />
                              Nova Atividade
                            </S.BotaoNovaAtividade>
                          </Link>
                        )}
                      </S.CabecalhoAtividades>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12}>
                      <S.FiltroContainer>
                        <div className="d-flex flex-wrap align-items-center justify-content-center">
                          <div className="mr-4 mb-2">
                            <strong style={{color: '#2c3e50', fontSize: '16px'}}>Status:</strong>
                            <button
                              type="button"
                              className="btn btn-link"
                              onClick={() => setDisponiveis(true)}
                            >
                              {disponiveis && <S.CheckIcon />} Disponíveis
                            </button>
                            <button
                              type="button"
                              className="btn btn-link"
                              onClick={() => setDisponiveis(false)}
                            >
                              {!disponiveis && <S.CheckIcon />} Expirados
                            </button>
                          </div>
                          
                          <div className="mb-2">
                            <strong style={{color: '#2c3e50', fontSize: '16px'}}>Tipo:</strong>
                            <button
                              type="button"
                              className="btn btn-link"
                              onClick={() => setTipo("Tema")}
                            >
                              {tipo === "Tema" && <S.CheckIcon />} Temas
                            </button>
                            <button
                              type="button"
                              className="btn btn-link"
                              onClick={() => setTipo("Simulado")}
                            >
                              {tipo === "Simulado" && <S.CheckIcon />} Simulados
                            </button>
                            <button
                              type="button"
                              className="btn btn-link"
                              onClick={() => setTipo("Tema Bônus")}
                            >
                              {tipo === "Tema Bônus" && <S.CheckIcon />} Bônus
                            </button>
                            <button
                              type="button"
                              className="btn btn-link"
                              onClick={() => setTipo("Todos")}
                            >
                              {tipo === "Todos" && <S.CheckIcon />} Todos
                            </button>
                          </div>
                        </div>
                      </S.FiltroContainer>
                    </Col>
                  </Row>
                  <Row>
                    {user.nivel === "a" && (
                      <Col xs={12} sm={6} md={4} lg={3} xl={3}>
                        <S.AtividadeCard>
                          <S.AtividadeHeader>
                            <S.TipoAviso>
                              <S.CreateIcon />
                            </S.TipoAviso>
                            <S.CaixaTexto>
                              <strong>Nova Atividade</strong>
                            </S.CaixaTexto>
                          </S.AtividadeHeader>
                          
                          <S.AtividadeContent>
                            <S.NovaAtividadeContainer>
                              <div style={{marginBottom: '20px', color: '#6c757d', fontSize: '12px', lineHeight: '1.4'}}>
                                Crie atividades com temas, simulados ou conteúdo bônus.
                              </div>
                              
                              <Link to={`/atividades/${id}`} style={{textDecoration: 'none'}}>
                                <S.BotaoAcao variant="success">
                                  ➕ Criar Nova
                                </S.BotaoAcao>
                              </Link>
                            </S.NovaAtividadeContainer>
                          </S.AtividadeContent>
                        </S.AtividadeCard>
                      </Col>
                    )}

                    {atividades &&
                      atividades.map((atividade) => (
                        <>
                          {!disponiveis ===
                            validaDataClasse(
                              atividade.entrega,
                              `${atividade.hora}:00`
                            ) && (
                            <Col xs={12} sm={6} md={4} lg={3} xl={3}>
                              <S.AtividadeCard>
                                {user.nivel === "a" && (
                                  <S.TopButton
                                    onClick={() =>
                                      setConfirmacao({
                                        tipo: "atividade",
                                        id: atividade.id,
                                        titulo: atividade.nome,
                                      })
                                    }
                                  >
                                    <OverlayTrigger
                                      key="top"
                                      placement="top"
                                      overlay={<Tooltip>Deletar</Tooltip>}
                                    >
                                      <S.DeletarIcone />
                                    </OverlayTrigger>
                                  </S.TopButton>
                                )}

                                <S.AtividadeHeader>
                                  <S.TipoAviso>
                                    <S.LearningAppIcon />
                                  </S.TipoAviso>

                                  <S.BadgeCustom
                                    className={
                                      atividade.genero === "Tema"
                                        ? "tema"
                                        : atividade.genero === "Simulado"
                                        ? "simulado"
                                        : "bonus"
                                    }
                                  >
                                    Aula {atividade.aula}: {atividade.genero}
                                  </S.BadgeCustom>
                                  
                                  <S.CaixaTexto>{atividade.nome}</S.CaixaTexto>
                                </S.AtividadeHeader>

                                <S.AtividadeContent>
                                  <S.InfoSection>
                                    <S.InfoLabel>Data para Entrega</S.InfoLabel>
                                    <S.DataEntrega>
                                      {formatarData(atividade.entrega)} {atividade.hora}
                                    </S.DataEntrega>
                                  </S.InfoSection>

                                  <S.BotoesContainer>
                                    <S.BotaoAcao
                                      variant="warning"
                                      onClick={() => {
                                        console.log('=== CLICOU NO MATERIAL DE APOIO ===');
                                        console.log('Dados da atividade:', atividade);
                                        console.log('Arquivo:', atividade.arquivo);
                                        console.log('Descrição:', atividade.descricao);
                                        setLgShow(true);
                                        setArquivo(atividade.arquivo);
                                        setApoio(atividade.descricao);
                                        setNomeAtividade(atividade.nome);
                                      }}
                                    >
                                      📚 Material de Apoio
                                    </S.BotaoAcao>

                                    {validaDataClasse(
                                      atividade.entrega,
                                      `${atividade.hora}:00`
                                    ) ? (
                                      <S.BotaoAcao variant="danger">
                                        ⏰ Vencido
                                      </S.BotaoAcao>
                                    ) : (
                                      <>
                                        {!clicado ? (
                                          <S.BotaoAcao
                                            variant="success"
                                            onClick={() => {
                                              console.log('Dados da atividade:', atividade);
                                              console.log('tema_id da atividade:', atividade.tema_id);
                                              setClicado(true);
                                              // Para turmas "Somente IA", usar o id da atividade como tema_id se tema_id for undefined
                                              const temaIdParaUsar = atividade.tema_id || atividade.id;
                                              console.log('tema_id que será usado:', temaIdParaUsar);
                                              criarRedacao(
                                                temaIdParaUsar,
                                                atividade.id,
                                                id
                                              );
                                            }}
                                          >
                                            ✏️ Criar Redação
                                          </S.BotaoAcao>
                                        ) : (
                                          <div style={{padding: '20px', textAlign: 'center'}}>
                                            <div className="d-flex justify-content-center mb-3">
                                              <div className="spinner-grow text-primary" role="status" style={{width: '1rem', height: '1rem', marginRight: '5px'}}>
                                                <span className="sr-only">Loading...</span>
                                              </div>
                                              <div className="spinner-grow text-success" role="status" style={{width: '1rem', height: '1rem', marginRight: '5px'}}>
                                                <span className="sr-only">Loading...</span>
                                              </div>
                                              <div className="spinner-grow text-warning" role="status" style={{width: '1rem', height: '1rem'}}>
                                                <span className="sr-only">Loading...</span>
                                              </div>
                                            </div>
                                            <strong style={{color: '#007bc6', fontSize: '14px'}}>Criando...</strong>
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </S.BotoesContainer>
                                </S.AtividadeContent>
                              </S.AtividadeCard>
                            </Col>
                          )}
                        </>
                      ))}
                  </Row>
                </>
              )}

              {showAlunos && <ListaAlunos turma={classe.name} id_turma={id} />}

              {showRedacoes && (
                <ListaRedacoes turma={classe.name} id_turma={id} />
              )}
            </>
          )}
        </Container>

        <Modal
          size="lg"
          show={lgShow}
          onHide={() => setLgShow(false)}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              <small>Material de Apoio</small>
              <br />
              <strong>{nomeAtividade}</strong>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {apoio}

            {arquivo && (
              <>
                <hr />

                <a
                  href={`https://redacoes.nyc3.digitaloceanspaces.com${arquivo}`}
                  rel="noreferrer"
                  title="material de apoio"
                  target="_blank"
                  className="btn btn-primary"
                >
                  Abrir Arquivo de apoio
                </a>
              </>
            )}
          </Modal.Body>
        </Modal>

        <Modal
          show={!!confirmacao}
          onHide={() => !excluindo && setConfirmacao(null)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: "18px", fontWeight: 700, color: "#a12727" }}>
              <i className="fas fa-triangle-exclamation mr-2"></i>
              {confirmacao?.tipo === "aviso" ? "Excluir aviso" : "Excluir atividade"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="mb-2" style={{ fontSize: "14.5px", color: "#3d4d5c" }}>
              Excluir {confirmacao?.tipo === "aviso" ? "o aviso" : "a atividade"}{" "}
              <strong>{confirmacao?.titulo}</strong>?
            </p>
            <p className="mb-0" style={{ fontSize: "13px", color: "#8698ab" }}>
              Esta ação não pode ser desfeita.
            </p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="light"
              disabled={excluindo}
              onClick={() => setConfirmacao(null)}
            >
              Cancelar
            </Button>
            <Button variant="danger" disabled={excluindo} onClick={executarExclusao}>
              {excluindo
                ? "Excluindo..."
                : confirmacao?.tipo === "aviso"
                ? "Excluir aviso"
                : "Excluir atividade"}
            </Button>
          </Modal.Footer>
        </Modal>
      </S.MainWrapper>
    </Template>
  );
}

export default Classe;
